var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "column" },
    _vm._l(_vm.dataList, function (value, index) {
      return _c("div", { key: index }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.formatFnc(value) || value || _vm.$t("emptyValue")) +
            "\n  "
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }